const initialState = {
    isLoading: false,
    driver:[],
  }
  export default initialState;